import { Checkbox as AntdCheckbox } from 'antd';
import styled from 'styled-components';
import { CheckboxCss } from './Checkbox';

const CheckboxGroup = styled(AntdCheckbox.Group)`
    ${CheckboxCss}

    /* Children should be start with checkbox component */
    & > * {
        margin-top: 1rem;
    }
`;

export default CheckboxGroup;
